module.exports = __webpack_public_path__ + "static/SquareSerif-Bold-webfont-d60731b2d03de47412055c7d8e1b1203.ttf";